import ProjectTypeBadge, { PROJECT_TYPE_BY_USED_BY_ITEM_TYPE } from "components/ProjectTypeBadge";

import { WorkerPoolUsedByItemType } from "../helpers";

type WorkerPoolUsedByTypeBadgeProps = {
  type: WorkerPoolUsedByItemType;
};

const WorkerPoolUsedByTypeBadge = ({ type }: WorkerPoolUsedByTypeBadgeProps) => {
  return <ProjectTypeBadge projectType={PROJECT_TYPE_BY_USED_BY_ITEM_TYPE[type]} />;
};

export default WorkerPoolUsedByTypeBadge;
